import { request } from "umi";

const urlPrefix = "/api/tenants/dispatch/route-lock";

export type RouteLockEntry = {
  user_id: number;
  appointment_date: string;
  is_locked: number;
  pending_requests: number;
};

export type RouteLockRequest = {
  id: number;
  user_id: number;
  technician_name: string;
  requested_by_user_id: number;
  requested_by_name: string;
  appointment_date: string;
  requested_at: string;
};

export type RouteLockStatus = {
  user_id: number;
  appointment_date: string;
  is_locked: boolean;
  locked_at: string | null;
  pending_request: {
    id: number;
    requested_by_user_id: number;
    requested_by_name: string;
    requested_at: string;
  } | null;
  active_passcode: { id: number; expires_at: string } | null;
};

/** GET locked routes + pending counts for a date range (EDB header icons). */
export async function getRouteLockList(start: string, end: string) {
  return request<API.ResultObject<{ routes: RouteLockEntry[] }>>(`${urlPrefix}/list`, {
    method: "GET",
    params: { start, end },
    withToken: true,
  }).then((res) => res.data?.routes ?? []);
}

/** GET full lock + passcode state for a single technician/date (modal detail). */
export async function getRouteLockStatus(user_id: number, appt_date: string) {
  return request<API.ResultObject<RouteLockStatus>>(`${urlPrefix}/status`, {
    method: "GET",
    params: { user_id, appt_date },
    withToken: true,
  }).then((res) => res.data);
}

/** GET all pending passcode requests for the tenant. */
export async function getRouteLockRequests() {
  return request<API.ResultObject<{ requests: RouteLockRequest[] }>>(`${urlPrefix}/requests`, {
    method: "GET",
    withToken: true,
  }).then((res) => res.data?.requests ?? []);
}

export async function lockRoute(user_id: number, appt_date: string) {
  return request<API.ResultObject<any>>(`${urlPrefix}/lock`, {
    method: "POST",
    data: { user_id, appt_date },
    withToken: true,
  }).then((res) => res.data);
}

export async function unlockRoute(user_id: number, appt_date: string) {
  return request<API.ResultObject<any>>(`${urlPrefix}/unlock`, {
    method: "POST",
    data: { user_id, appt_date },
    withToken: true,
  }).then((res) => res.data);
}

/** Approve a request: generates the passcode and texts it to the technician. */
export async function approvePasscodeRequest(request_id: number) {
  return request<API.ResultObject<any>>(`${urlPrefix}/requests/approve`, {
    method: "POST",
    data: { request_id },
    withToken: true,
  }).then((res) => res.data);
}

export async function denyPasscodeRequest(request_id: number) {
  return request<API.ResultObject<any>>(`${urlPrefix}/requests/deny`, {
    method: "POST",
    data: { request_id },
    withToken: true,
  }).then((res) => res.data);
}
